import {dataTestId} from '@hconnect/uikit'
import {Box, useTheme} from '@mui/material'
import React, {forwardRef} from 'react'

import {GANTT_CHART_ROW_HEIGHT} from '../constants'
import {AddGanttChartItemProps} from '../types/common'

interface GanttChartAddItemProps<T> {
  selectedItemXAxisValue: T
  chartStartBoundary: T
  chartEndBoundary: T
  stepWidth: number
  rowId: number
  onAddItem?: (props: AddGanttChartItemProps<T>) => void | Promise<void>
}
function GanttChartAddItemWrapper<T>(
  {
    chartStartBoundary,
    chartEndBoundary,
    stepWidth,
    rowId,
    selectedItemXAxisValue,
    onAddItem
  }: GanttChartAddItemProps<T>,
  ref: React.Ref<HTMLDivElement>
) {
  const theme = useTheme()

  return (
    <Box
      ref={ref}
      sx={{
        ...theme.typography.h2,
        display: 'flex',
        flexDirection: 'column',
        flex: '1',
        justifyContent: 'center',
        alignItems: 'center',
        overflow: 'visible',
        whiteSpace: 'nowrap',
        color: ({palette}) => palette.text.primary,
        height: `${GANTT_CHART_ROW_HEIGHT}px`,
        width: `${stepWidth}px`,
        cursor: 'pointer',
        pointerEvents: 'auto',
        position: 'absolute',
        left: 0,
        top: 0
      }}
      onClick={() =>
        onAddItem &&
        onAddItem({
          chartStartBoundary,
          chartEndBoundary,
          stepWidth,
          selectedItemXAxisValue,
          rowId
        })
      }
      {...dataTestId('gantt_chart_click_button')}
    >
      +
    </Box>
  )
}

export const GanttChartAddItem = React.memo(forwardRef(GanttChartAddItemWrapper)) as <T>(
  props: GanttChartAddItemProps<T> & {ref?: React.Ref<HTMLDivElement>}
) => ReturnType<typeof GanttChartAddItemWrapper>
